// Где запущено приложение: внутри Telegram Mini App или в обычном браузере (сайт).
// В TG авторизация идёт через initData, на сайте — через cookie-сессию.
export function isTelegram(): boolean {
  return !!window.Telegram?.WebApp?.initData;
}
